export class MonitorFilter {
  account: string;
  accountingNature: string;
  affiliation: string;
  approvalCode: string;
  cardBrand: string;
  endDateId: string;
  merchantId: number;
  operationType: string;
  serviceId: string;
  startDateId: string;
  status: string;
}
